import { createSignal } from "solid-js"

// The browser fires this once if the app meets PWA installability criteria.
// We must capture it synchronously — it won't re-fire.
let deferredPrompt: any = null

const [canInstall, setCanInstall] = createSignal(false)
const [installed, setInstalled] = createSignal(false)

/** True on iPhone/iPad (Safari never fires beforeinstallprompt) */
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent)

/** True when already running as installed PWA (standalone or fullscreen) */
export const isStandalone = () =>
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as any).standalone === true

/** Reactive: true when Chrome/Android install prompt is available */
export const canInstallPWA = canInstall

/** Reactive: true once the user accepted the install prompt this session */
export const installedPWA = installed

export function initPWAInstall() {
    if (isStandalone()) return // already installed, nothing to do

    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault() // stop automatic mini-infobar on Android
        deferredPrompt = e
        setCanInstall(true)
    })

    window.addEventListener("appinstalled", () => {
        deferredPrompt = null
        setCanInstall(false)
        setInstalled(true)
    })
}

export async function triggerInstall() {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === "accepted") {
        deferredPrompt = null
        setCanInstall(false)
        setInstalled(true)
    }
}
